import { Image } from '@ckeditor/ckeditor5-image';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import {
  TabNames,
  MobileView,
  common_components_map,
  c1,
  c2,
  c16,
  c18,
} from "src/app/core/services/constants";
import { Menu, Tab } from "src/app/core/services/interface";
import { cl } from "@fullcalendar/core/internal-common";
import { BuilderService } from "src/app/sharedservices/builder.service";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { csLocale } from "ngx-bootstrap/chronos";
import { Bold } from "@ckeditor/ckeditor5-basic-styles";
import { ActiveToast, ToastrService } from "ngx-toastr";
import { ListAppRelease } from 'src/app/core/services/outbound';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: "app-mobile-view",
  templateUrl: "./mobile-view.component.html",
  styleUrls: ["./mobile-view.component.scss"],
})
export class MobileViewComponent implements OnInit, OnDestroy {
  updateBuilderComponentSubscription: any;
  colorsComponentSubscription: any;
  getAppConfigSubscription: any;
  getAppReleaseSubscription: any;
  appReleasesListSubscription: any;
  sendAppConfigAPKStatusSubscription: any;
  verifySubscription: any;
  errorAPK = false;
  tabNames = TabNames;
  mode;
  mobileViewModeMap;
  inputData;
  image: string;
  emptyImage: string;
  tab_bgimage: string;
  start_color: string;
  end_color: string;
  bg_color: string;
  sidemode: boolean;
  theme: any = {};
  isAndroid: boolean;
  isSide: boolean;
  isTabView: boolean;
  color_schema: any;
  color_schema_ios: any;
  light: boolean;
  colors: any = {};
  outline: string;
  view: string;
  userShowTabView: boolean;
  disableDrawer: boolean;
  isDrawerView: boolean;
  showDrawer: boolean;
  bgObject: any;
  surfaceColor : string;
  modalRef?: BsModalRef;
  releaseForm: any;

  @Input() inputTab: Tab;
  @Input() splashTab: Tab;
  @Input() inputMenuId: string;
  @Input() menuGroup: any;
  @Input() onlyMobile: boolean = false;
  @Input() tabTheme: boolean = false;

  mobileView = MobileView;
  fontResize = true;
  font;
  component_id: string = "mobile_view";
  isLight = true;
  latestRequestRef: string;
  qrcodeUrl = null;
  qrLoading = false;
  planId = null;
  buildDetails: any =null;
  buildDetailsSecond: any=null;

  constructor(
    private ws: WebsocketService,
    public mdw: MiddlwareService,
    private builderService: BuilderService,
    private modalService: BsModalService,
    public indexDBService: IndexDBService,
    public ref: ChangeDetectorRef,
    public toastService: ToastrService
  ) {}

  @ViewChild("tabset", { static: true }) tabset: any;

  async ngOnInit() {
  this.buildDetails = this.mdw.getBuildsDetails();
  this.buildCheck(this.buildDetails)

  this.light = localStorage.getItem("mode")[15] == c16.LIGHT ? true : false;
    this.getAppConfigSubscription = this.mdw.getAppConfigContainer$.subscribe(
      async (data) => {
        if (data) {
          try {
            await this.colorInitialize(1);
            // this.initialize();
          } catch (error) {
            setTimeout(async () => {
              await this.colorInitialize(2);
              // this.initialize();
            }, 1000);
          }
        }
      }
    );

    this.updateBuilderComponentSubscription = this.mdw.updateBuilderComponentContainer$.subscribe(async (data) => {
      if (data && data.tab) {
        this.inputData = data.tab;
        this.theme = this.tabTheme
          ? this.mdw.tabMobileTheme(this.inputTab)
          : this.mdw.mobileTheme(data.tab);
        if (localStorage.getItem("mode")[0] == c1.ANDROID) {
          this.tabset.tabs[0].active = true;
        } else {
          this.tabset.tabs[1].active = true;
        }
        this.initialize();
        try {
          this.colorInitialize(3);
        } catch (error) {}
      }
    });

    this.colorsComponentSubscription = this.mdw.colorsComponentContainer$.subscribe(async (data) => {
      if (
        data &&
        data.color_schema &&
        data.color_schema_ios &&
        data.light != null
      ) {
        this.colors = data;
        this.light = data.light;
        this.colors.light = data.light;
        this.isLight = this.colors["light"];
        this.color_schema = this.light
          ? this.colors.color_schema.schemes.light
          : this.colors.color_schema.schemes.dark;
        this.color_schema_ios = this.light
          ? this.colors.color_schema_ios.schemes.light
          : this.colors.color_schema_ios.schemes.dark;
        if (this.colors){
          // console.log("mobile colors", this.colors);
          this.surfaceColor = this.isAndroid ? this.builderService.buttonColor(null, this.colors.color_schema, null, 'surface', this.light):this.builderService.buttonColor(null, this.colors.color_schema_ios, null, 'surface', this.light)
        }
        this.initialize();
      }
    });

    this.getAppReleaseSubscription = this.ws.getAppReleaseContainer$.subscribe((appReleaseData) => {
      if(appReleaseData != null){
        if (appReleaseData.url != null) {
          this.qrcodeUrl = appReleaseData.url;
          this.qrLoading = false;
          this.mdw.trackEvent('build_complete', {
          build_click:localStorage.getItem('build_click')
          });
        } else {
          this.qrcodeUrl = null;
          this.qrLoading = true;
        }
    this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
    this.isSide = localStorage.getItem("mode")[1]== c2.SIDE? true: false;
    this.isTabView = localStorage.getItem("mode")[17]== c18.SIDEVIEW? false: true;

      }
    });

    this.appReleasesListSubscription = this.ws.appReleasesContainer$.subscribe((listAppReleaseData) => {
      if (listAppReleaseData && listAppReleaseData.values != null && listAppReleaseData.values.length != 0){
        for(let i = 0; i < listAppReleaseData.values.length; i++){
          if(listAppReleaseData.values[i].status != "Failed" && listAppReleaseData.values[i].os == 0){
            if(listAppReleaseData.values[i].url != null){
              this.qrcodeUrl = listAppReleaseData.values[i].url;
              this.qrLoading = false;
            } else {
              this.qrcodeUrl = null;
              this.qrLoading = true;
            }
            break;
          }
        }
      }
    });

this.sendAppConfigAPKStatusSubscription = this.mdw.sendAppConfigAPKStatusContainer$.subscribe(async (data) => {
      if (data) {
      if (data.error){
      this.errorAPK = true;
      }else {
        this.qrLoading= true;
      }
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {
        this.planId = this.mdw.getPlanDetails()?.plan_id;
        this.ws.processMethod(new ListAppRelease(null));
        this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
        this.isSide = localStorage.getItem("mode")[1]== c2.SIDE? true: false;
        this.isTabView = localStorage.getItem("mode")[17]== c18.SIDEVIEW? false: true;

      }
    });
  }

  initialize() {
    // console.log("this.theme",this.theme)
    this.buildCheck(this.buildDetailsSecond)
    this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
    this.isSide = localStorage.getItem("mode")[1]== c2.SIDE? true: false;
    this.isTabView = localStorage.getItem("mode")[17]== c18.SIDEVIEW? false:true;

    if (
      localStorage.getItem("mode")[0] == c1.ANDROID &&
      this.tabset &&
      this.tabset.tabs &&
      this.tabset.tabs[0] &&
      this.tabset.tabs[0].active
    ) {
      this.tabset.tabs[0].active = true;
    } else if (
      this.tabset &&
      this.tabset.tabs &&
      this.tabset.tabs[1] &&
      this.tabset.tabs[1].active
    ) {
      this.tabset.tabs[1].active = true;
    }


    if (this.isAndroid && this.color_schema) {
      this.bg_color = this.color_schema.m2CSurface;
      this.outline = this.color_schema.outlineVariant;
    } else if (this.color_schema_ios) {
      this.bg_color = this.color_schema_ios.surface;
      this.outline = this.color_schema_ios.outlineVariant;
    }
    this.bgInitialize(this.inputMenuId, this.inputTab);
  }

  async colorInitialize(no) {
    // console.log("no", no);
    const appHome = this.indexDBService.getItem("app", "home");
    if (appHome) {
      appHome.onsuccess = async (event) => {
        if (appHome.result) {
          this.colors["color_schema"] = appHome.result.app.tabs.color_schema;
          this.colors["color_schema_ios"] =
            appHome.result.app.tabs.color_schema_ios;
          this.colors["light"] =
            localStorage.getItem("mode")[15] == c16.LIGHT ? true : false;
          this.isLight = this.colors["light"];
          this.color_schema = this.light
            ? this.colors.color_schema.schemes.light
            : this.colors.color_schema.schemes.dark;
          this.color_schema_ios = this.light
            ? this.colors.color_schema_ios.schemes.light
            : this.colors.color_schema_ios.schemes.dark;
          if (this.colors){
//          console.log("mobile colors", this.colors);
//          this.surfaceColor = this.isAndroid ? this.builderService.buttonColor(null, this.colors.color_schema, null, 'surface', this.light):this.builderService.buttonColor(null, this.colors.color_schema_ios, null, 'surface', this.light)
          }

          this.initialize();
        }
      };
    }
  }


async bgInitialize(menuId, inputTab) {
  const requestRef = this.mdw.makeRef(16);

  this.latestRequestRef = requestRef;

  this.bgObject = null;

  const getMenuById = async (menuId) => {
    return new Promise((resolve) => {
      const menuRequest = this.indexDBService.getItem("menu", menuId);
      menuRequest.onsuccess = () => resolve(menuRequest.result);
      menuRequest.onerror = () => resolve(null);
    });
  };

  const getTabById = async (tabId) => {
    return new Promise((resolve) => {
      const tabRequest = this.indexDBService.getItem("tab", tabId);
      tabRequest.onsuccess = () => resolve(tabRequest.result);
      tabRequest.onerror = () => resolve(null);
    });
  };

  const processMenu = async (menu) => {
    if (menu && menu.menu_bg) {
      this.menuBackground(menu.menu_bg);
      return true;
    }
    if (menu && menu.menu_group) {
      let tab: any;
       tab = await getTabById(menu.menu_group);
      if (this.latestRequestRef !== requestRef) return true;
      if (tab && tab.tab_bg) {
        this.menuBackground(tab.tab_bg);
        return true;
      }
    }
    return false;
  };

  let menu = menuId ? await getMenuById(menuId) : null;
  if (this.latestRequestRef !== requestRef) return;

  if (await processMenu(menu)) return;

  if ((!menuId || menuId === null || menuId === undefined) && inputTab && inputTab.menu_id) {
    menu = await getMenuById(inputTab.menu_id);
    if (this.latestRequestRef !== requestRef) return;
    if (await processMenu(menu)) return;
  }

  if (inputTab && inputTab.tab_bg) {
    this.menuBackground(inputTab.tab_bg);
    return;
  }

  if (this.latestRequestRef !== requestRef) return;

  this.menuBackground(null);
}

menuBackground(bgObject) {
  let image: string =null
  let start: string = null;
  let end: string = null;

  if (bgObject){
    let image_light = (bgObject && bgObject.image)? bgObject.image:null
    let image_dark = (bgObject && bgObject.image_dark)? bgObject.image_dark :null
    image = this.isLight? image_light: image_dark? image_dark:image_light
    start = this.isLight? bgObject.start: bgObject.start_dark;
    end = this.isLight? bgObject.end: bgObject.end_dark;
  }

    if (bgObject && image) {
    this.tab_bgimage = image;
    this.start_color = null;
    this.end_color = null;
    this.bg_color = null;
  } else if (bgObject && (start || end)) {
    this.tab_bgimage = null;
    this.start_color = start || null;
    this.end_color = end || null;
    this.bg_color = (!this.end_color) ? this.start_color : (!this.start_color ? this.end_color : null);
  } else {
    this.tab_bgimage = null;
    this.start_color = null;
    this.end_color = null;
    this.bg_color = null;
  }
}

get setTabBg() {
  if (this.tab_bgimage) {
    return {
      "background-image": `url(${this.tab_bgimage})`,
      "background-position": "center",
      "background-repeat": "no-repeat",
      "background-size": "cover",
    };
  } else if (this.start_color && this.end_color) {
    return {
      "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
    };
  } else if (this.bg_color) {
    return { background: this.bg_color };
  }
  return { "background": this.surfaceColor }
  };



  onChangeView(event) {
    let modes: any;
    if (event.id == "ios") {
      modes = [{ id: c1.ID, value: c1.IOS }];
    } else {
      modes = [{ id: c1.ID, value: c1.ANDROID }];
    }
    this.mdw.changeMobileTheme(modes);
    let data = { ...{ tab: this.inputData, offcanvasRefersh: true } };
    this.mdw._updateBuilderComponentContainer.next(data);
    this.mdw._schemeChangeContainer.next(true);
  }

  onChangeMode(event) {
    let modes: any;
    if (event.id == "dark") {
      modes = [{ id: c16.ID, value: c16.DARK }];
      this.colors["light"] = false;
      this.light = false;
    } else {
      modes = [{ id: c16.ID, value: c16.LIGHT }];
      this.colors["light"] = true;
      this.light = true;
    }
    this.colors["component_id"] = this.component_id;
    this.mdw._colorsComponentContainer.next(this.colors);
    this.mdw.changeMobileTheme(modes);
  }

  buildMessage(mobileClick) {
    this.toastService.info(
      "Preview only. Build the app for full functionality.",
      "",
      { timeOut: 4000, positionClass: "toast-bottom-right" }
    );
    // this.centerModal(mobileClick)
  }

  getQRCodeColor(){
    const cs = getComputedStyle(document.documentElement);
    return cs.getPropertyValue('--onSurface').trim() || '#000000';
  }

  toggleSideMenu(enable){
 let modes
 if (enable) {
      this.isTabView = true;
      modes = [{ id: c18.ID, value: c18.TABVIEW }];
    } else {
      this.isTabView = false;
      modes = [{ id: c18.ID, value: c18.SIDEVIEW }];
}
   this.mdw.changeMobileTheme(modes);
    let data = { ...{ tab: this.inputData, offcanvasRefersh: true } };
    this.mdw._updateBuilderComponentContainer.next(data);
    this.mdw._schemeChangeContainer.next(true);
}

centerModal(centerDataModal: any) {
    this.modalRef = this.modalService.show(centerDataModal, {
      class: "modal-md modal-dialog-centered",
    });
  }

  buildEvaluationApk(){

  this.mdw._sendAppConfigAPKContainer.next(true)

  const build_click = localStorage.setItem('build_click','mobile_button')
  this.mdw.trackEvent('build_start', {
  build_click: build_click
  });
  }

  async buildCheck(buildDetails){

    if(buildDetails){
    this.releaseForm = {
      app: localStorage.getItem("sapp_id") || '',
      system: 0,
      versionName: '',
      versionDesc: '',
      androidFormat: 'apk'
    };
   let results = await this.mdw.validateConfigAPK(buildDetails.androidFormat);
      this.mdw.showPageSettingsValidation('build_id', results);
      this.errorAPK = false;
       results.forEach(result => {
        if(result.errorCode != 0){
          this.errorAPK = true;

        this.mdw.trackEvent('build_validate', {
        build_button: localStorage.getItem("build_click"),
        build_status: 'error'
        });
          return;
        }

        this.mdw.trackEvent('build_validate', {
        build_button: localStorage.getItem("build_click"),
        build_status: 'success'
        });

      });
      this.buildDetailsSecond=buildDetails;
    }

  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }

    if (this.getAppConfigSubscription) {
      this.getAppConfigSubscription.unsubscribe();
    }

    if (this.getAppReleaseSubscription) {
      this.getAppReleaseSubscription.unsubscribe();
    }

    if (this.appReleasesListSubscription) {
      this.appReleasesListSubscription.unsubscribe();
    }

    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }

    if (this.sendAppConfigAPKStatusSubscription) {
      this.sendAppConfigAPKStatusSubscription.unsubscribe();
    }

  }
}
